import React from 'react'
import { Col, Row } from 'reactstrap'
import { Icon, IconNameType } from '../Icon'

export type ScheduleLegendsProps = {
  /**
   * Array con las leyendas a renderizar ({id: number, name: string, icon?: IconNameType})
   * Los ids deben estar entre 1 y 8 (para calzar con los colores mantenidos)
   */
  legends: ScheduleLegendType[]
}

export type ScheduleLegendType = {
  id: number
  name: string
  /**
   * Icono opcional a mostrar en lugar del cuadro de color
   */
  icon?: IconNameType
}

/**
 * Componente utilizado para renderizar las leyendas asociadas a los horarios
 * desplegados en el componente Schedule
 */
export const ScheduleLegends = ({ legends }: ScheduleLegendsProps) => {
  return (
    <Row className='g-legends-container'>
      {legends.map((legend) => (
        <Col xs={6} sm={4} md={3} className='pb-4' key={`legend_${legend.id}`}>
          {legend.icon ? (
            <Icon name={legend.icon} size={26} className='mr-3' />
          ) : (
            <span className={`legend bg-schedule-${legend.id}`} />
          )}
          {legend.name}
        </Col>
      ))}
    </Row>
  )
}
